module.exports = __webpack_public_path__ + "img/card-hipercard.fff204f0.svg";